import {
  dataAttribute,
  DataAttributes,
  Stack,
  TextBadge,
  TextBadgeColor,
  TextBadgeSize
} from "@bps/fluent-ui";
import { OutboundCommDto } from "@libs/gateways/comms/CommsGateway.dtos.ts";

import {
  outboundCommStatusesColours,
  outboundCommStatusesText
} from "../components/CommunicationHistory.types.ts";

interface CommunicationStatusCellProps {
  item?: OutboundCommDto;
}

export const CommunicationStatusCell: React.FC<
  CommunicationStatusCellProps
> = ({ item }) => {
  let badgeColour: TextBadgeColor;
  let statusText: string;

  if (item) {
    badgeColour = outboundCommStatusesColours[item.statusCode];
    statusText = outboundCommStatusesText[item.statusCode];
  } else {
    badgeColour = TextBadgeColor.lightGrey;
    statusText = "";
  }
  return (
    <Stack
      horizontal
      horizontalAlign="space-between"
      styles={{ root: { width: "100%" } }}
    >
      {item && (
        <TextBadge
          badgeColor={badgeColour}
          badgeSize={TextBadgeSize.medium}
          {...dataAttribute(
            DataAttributes.Element,
            "communicationHistory-badge"
          )}
        >
          {statusText}
        </TextBadge>
      )}
    </Stack>
  );
};
